import React from "react";

export function GuidedCallActionIcons(props) {
  return (
    <div className="tw:flex tw:flex-row tw:items-center tw:justify-center tw:pl-5">
      {props.workflow.details.iconComponents.map((component) => {
        return component(props);
      })}
    </div>
  );
}
